module.exports = __webpack_public_path__ + "static/media/tracefinancialblue 700x250.b2a1da71.png";